import React, { useState } from 'react';
import './WebsiteGeneratorForm.css';
import { useNavigate } from "react-router-dom";


const WebsiteGeneratorForm = ({ onSubmit }) => {
  const [formData, setFormData] = useState({
    companyName: '',
    description: '',
    businessType: '',
    productsServices: '',
    websiteStyle: '',
    colors: '',
    targetAudience: '',
    contentAI: [],
    email: '',
    phone: '',
    socialMedia: '',
    logo: null,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (type === 'checkbox') {
      setFormData(prevState => {
        const newContentAI = checked
          ? [...prevState.contentAI, value]
          : prevState.contentAI.filter(item => item !== value);
        return { ...prevState, contentAI: newContentAI };
      });
    } else if (type === 'file') {
      setFormData({ ...formData, [name]: e.target.files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

 const handleSubmit = (e) => {
  e.preventDefault();

  // Symulacja AI — możesz później zamienić to na fetch() do backendu
  const generatedWebsite = `
    <section style="padding: 2rem">
      <h1 style="color: #5a4ff3;">${formData.businessName}</h1>
      <p>${formData.description}</p>
      <p><strong>Styl:</strong> ${formData.style}</p>
      ${formData.additionalFeatures && `<p><strong>Funkcje:</strong> ${formData.additionalFeatures}</p>`}
      <p><em>Skontaktuj się z nami: ${formData.contactEmail}</em></p>
    </section>
  `;

  // Wywołujemy funkcję przekazaną jako props z wygenerowanym HTML
  onSubmit(generatedWebsite);
};
 
  return (
    <form className="website-generator-form" onSubmit={handleSubmit}>
      <h2>📑 Formularz generatora stron SiteForge AI</h2>

      <label>Nazwa firmy/projektu:</label>
      <input type="text" name="companyName" value={formData.companyName} onChange={handleChange} required/>

      <label>Krótki opis działalności:</label>
      <textarea name="description" value={formData.description} onChange={handleChange} required/>

      <label>Typ działalności:</label>
      <select name="businessType" value={formData.businessType} onChange={handleChange} required>
        <option value="">Wybierz typ działalności</option>
        <option>Firma usługowa</option>
        <option>Firma handlowa</option>
        <option>Blog</option>
        <option>Portfolio</option>
        <option>Startup technologiczny</option>
        <option>Inne</option>
      </select>

      <label>Produkty / Usługi:</label>
      <textarea name="productsServices" value={formData.productsServices} onChange={handleChange}/>

      <label>Styl strony:</label>
      <select name="websiteStyle" value={formData.websiteStyle} onChange={handleChange} required>
        <option value="">Wybierz styl strony</option>
        <option>Nowoczesny</option>
        <option>Minimalistyczny</option>
        <option>Biznesowy</option>
        <option>Kreatywny</option>
        <option>Klasyczny</option>
      </select>

      <label>Preferowana kolorystyka:</label>
      <input type="text" name="colors" value={formData.colors} placeholder="np. niebieski, biały" onChange={handleChange}/>

      <label>Grupa docelowa:</label>
      <textarea name="targetAudience" value={formData.targetAudience} onChange={handleChange}/>

      <label>Treści generowane przez AI:</label>
      <label><input type="checkbox" name="contentAI" value="all" onChange={handleChange}/> Cała treść</label>
      <label><input type="checkbox" name="contentAI" value="about" onChange={handleChange}/> Sekcja "O nas"</label>
      <label><input type="checkbox" name="contentAI" value="products" onChange={handleChange}/> Opisy produktów/usług</label>
      <label><input type="checkbox" name="contentAI" value="faq" onChange={handleChange}/> FAQ</label>

      <label>E-mail kontaktowy:</label>
      <input type="email" name="email" value={formData.email} onChange={handleChange} required/>

      <label>Telefon (opcjonalnie):</label>
      <input type="tel" name="phone" value={formData.phone} onChange={handleChange}/>

      <label>Media społecznościowe (opcjonalnie):</label>
      <input type="url" name="socialMedia" value={formData.socialMedia} onChange={handleChange}/>

      <label>Logo (opcjonalnie):</label>
      <input type="file" name="logo" onChange={handleChange}/>

      <button type="submit">🛠 Generuj stronę</button>
    </form>
  );
};

export default WebsiteGeneratorForm;
